import jMoment from 'moment-jalaali';
import { PriceLabel } from 'components';
const toolCodeEnum = {
  SETTLEMENT_TOOL_PAYA: 'پایا',
  SETTLEMENT_TOOL_CARD: 'کارت بانکی',
  SETTLEMENT_TOOL_SATNA: 'ساتنا',
};
const periodEnum = {
  NO_PERIOD: ' بدون دوره',
  YEAR_PERIOD: 'سالانه',
  MONTH_PERIOD: 'ماهانه',
  WEEK_PERIOD: 'هفتگی',
  DAY_PERIOD: 'روزانه',
};
const requestType = {
  MULTI_CONFIRMATION_TYPE_INVOICE: 'فاکتور',
  MULTI_CONFIRMATION_TYPE_DELEGATION_RULE: 'تفویض وجه',
  MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER: 'بن تخفیف مبلغی',
  MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER: 'بن تخفیف درصدی',
  MULTI_CONFIRMATION_TYPE_TRANSFER: 'انتقال وجه',
  MULTI_CONFIRMATION_TYPE_SETTLEMENT: 'برداشت وجه',
  MULTI_CONFIRMATION_TYPE_VOUCHER: 'بن',
};

// این تابع دیتای مربوط به بن شارژ رو جنریت میکنه
const generateDataCreditVouther = (data) => {
  return {
    id: data?.id,
    creationDate: data?.creationDate,
    expireDate: data?.expireDate,
    wallet: data?.multiConfirmationSrv?.wallet,
    guildSrv: data?.multiConfirmationSrv?.guildSrv,
    startDate: data?.requiredInfoToConfirm?.startDate,
    expireEndDate: data?.requiredInfoToConfirm?.expireDate,
    amount: data?.requiredInfoToConfirm?.amount,
    count: data?.requiredInfoToConfirm?.['count[]']?.[0],
    description: data?.requiredInfoToConfirm?.['description[]']?.[0],
    typeCode: data?.multiConfirmationSrv?.typeCode,
  };
};
// این تابع دیتای مربوط به بن تخفیف رو جنریت میکنه
const generateDataDiscountVouther = (data) => {
  return {
    id: data?.id,
    creationDate: data?.creationDate,
    expireDate: data?.expireDate,
    wallet: data?.multiConfirmationSrv?.wallet,
    guildSrv: data?.multiConfirmationSrv?.guildSrv,
    startDate: data?.requiredInfoToConfirm?.['effectiveDates[]']?.[0],
    expireEndDate: data?.requiredInfoToConfirm?.expireDate,
    amount: data?.requiredInfoToConfirm?.amount,
    discountPercentage: data?.requiredInfoToConfirm?.['discountPercentage[]']?.[0],
    count: data?.requiredInfoToConfirm?.['count[]']?.[0],
    description: data?.requiredInfoToConfirm?.['description[]']?.[0],
    typeCode: data?.multiConfirmationSrv?.typeCode,
  };
};
// این تابع دیتای مربوط به انتقال وجه  رو جنریت میکنه
const generateDataTransferCredit = (data) => {
  return {
    id: data?.id,
    creationDate: data?.creationDate,
    expireDate: data?.expireDate,
    wallet: data?.multiConfirmationSrv?.wallet,
    guildSrv: data?.multiConfirmationSrv?.guildSrv,
    destinationAccount: data?.requiredInfoToConfirm?.guildSrvList?.[1]?.name,
    startDate: data?.requiredInfoToConfirm?.startDate,
    expireEndDate: data?.requiredInfoToConfirm?.expireDate,
    amount: data?.requiredInfoToConfirm?.amount,
    description: data?.requiredInfoToConfirm?.description,
    typeCode: data?.multiConfirmationSrv?.typeCode,
    firstName: data?.requiredInfoToConfirm?.contactInfo?.firstName || '',
    lastName: data?.requiredInfoToConfirm?.contactInfo?.lastName || '',
    username: data?.requiredInfoToConfirm?.contactInfo?.username || '',
  };
};

// این تابع دیتای مربوط به تفویض وجه  رو جنریت میکنه
const generateDataDelegation = (data) => {
  return {
    id: data?.id,
    creationDate: data?.creationDate,
    expireDate: data?.expireDate,
    wallet: data?.multiConfirmationSrv?.wallet,
    guildSrv: data?.multiConfirmationSrv?.guildSrv,
    destinationAccount: data?.requiredInfoToConfirm?.guildSrvList?.[1]?.name,
    startDate: data?.requiredInfoToConfirm?.startDate,
    expireEndDate: data?.requiredInfoToConfirm?.expireDate,
    amount: data?.requiredInfoToConfirm?.amount,
    name: data?.requiredInfoToConfirm?.name, // تخصیص به
    uniqueId: data?.requiredInfoToConfirm?.uniqueId,
    maxTryCount: data?.requiredInfoToConfirm?.maxTryCount,
    description: data?.requiredInfoToConfirm?.description,
    typeCode: data?.multiConfirmationSrv?.typeCode,
  };
};

// این تابع دیتای مربوط به برداشت وجه  رو جنریت میکنه
const generateDataWithraw = (data) => {
  return {
    id: data?.id,
    creationDate: data?.creationDate,
    expireDate: data?.expireDate,
    wallet: data?.multiConfirmationSrv?.wallet,
    guildSrv: data?.multiConfirmationSrv?.guildSrv,
    amount: data?.requiredInfoToConfirm?.amount,
    toolCode: data?.requiredInfoToConfirm?.toolCode,
    toolId: data?.requiredInfoToConfirm.toolId,
    firstName: data?.requiredInfoToConfirm?.firstName,
    lastName: data?.requiredInfoToConfirm?.lastName,
    paymentId: data?.requiredInfoToConfirm?.paymentId,
    description: data?.requiredInfoToConfirm?.description,
    uniqueId: data?.requiredInfoToConfirm?.uniqueId,
    typeCode: data?.multiConfirmationSrv?.typeCode,
  };
};
const generateDataFactor = (data) => {
  return {
    id: data?.id,
    creationDate: data?.creationDate,
    expireDate: data?.expireDate,
    wallet: data?.multiConfirmationSrv?.wallet,
    guildSrv: data?.multiConfirmationSrv?.guildSrv,

    factorId: data?.factorDetails?.id,
    date: data?.factorDetails?.issuanceDate,
    allPrice: data?.factorDetails?.payableAmount,
    sellerName: data?.factorDetails?.issuerSrv?.name,
    buyName: data?.factorDetails?.userSrv?.name,
  };
};

// این فیلدها توی همه استتوس ها مشترک است . اینجا یک بار نوشتیم و در بقیه بصورت اسپرید اضافه و از اینا استفاده میکنیم
const shareFields = (data) => {
  return [
    {
      titleEn: 'requestId',
      titleFa: 'شناسه درخواست:',
      value: data?.id,
      isShow: !!data?.id,
    },
    {
      titleEn: 'createDate',
      titleFa: 'تاریخ ایجاد درخواست:',
      value: data?.creationDate
        ? jMoment(new Date(parseInt(data?.creationDate)))?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.creationDate,
    },
    {
      titleEn: 'expireDate',
      titleFa: 'تاریخ انقضا درخواست:',
      value: data?.expireDate
        ? jMoment(new Date(parseInt(data?.expireDate)))?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.expireDate,
    },

    {
      titleEn: 'discountName',
      titleFa: 'نام حساب مبدا:',
      value: data?.wallet?.name || data?.guildSrv?.name,
      isShow: !!data?.wallet?.name || !!data?.guildSrv?.name,
    },
  ];
};

/**
 * برداشت وجه
 */
export const WithrawFields = (obj, isGroup = false, currencyText) => {
  const data = generateDataWithraw(obj);
  let allFields = [
    ...shareFields(data),
    {
      titleEn: 'operationType',
      titleFa: 'نوع عملیات:',
      value: `${isGroup == true ? 'برداشت وجه گروهی' : 'برداشت وجه تکی'}`,
      isShow: true,
    },
    {
      titleEn: 'amount',
      titleFa: 'مبلغ:',
      value: (
        <>
          <PriceLabel amount={data?.amount} currency={currencyText}/>
        </>
      ),
      isShow: !!data?.amount,
    },
    {
      titleEn: 'toolCode',
      titleFa: 'نوع برداشت:',
      value: toolCodeEnum[data?.toolCode],
      isShow: !!data?.toolCode,
    },
    {
      titleEn: 'destination',
      titleFa: 'مقصد:',
      value: data?.toolId,
      isShow: !!data?.toolId,
    },
    {
      titleEn: 'fullName',
      titleFa: 'نام و نام خانوادگی:',
      value: `${data?.firstName} ${data?.lastName}`,
      isShow: !!(data?.firstName || data?.lastName),
    },
    {
      titleEn: 'paymentId',
      titleFa: 'شناسه واریز:',
      value: data?.paymentId,
      isShow: !!data?.paymentId,
    },
    {
      titleEn: 'description',
      titleFa: 'توضیحات:',
      value: data?.description,
      isShow: !!data?.description,
    },
    {
      titleEn: 'uniqueId',
      titleFa: 'شناسه یکتا:',
      value: data?.uniqueId,
      isShow: !!data?.uniqueId,
    },
  ];
  return allFields;
};
/**
 * تفویض وجه
 */
export const delegationFields = (obj, isGroup = false, currencyText) => {
  let usePeriodCount = null;
  let periodCount = null;
  if (
    (obj?.requiredInfoToConfirm?.usePeriodCount ||
      obj?.requiredInfoToConfirm?.usePeriodCount == 0) &&
    periodEnum[obj?.requiredInfoToConfirm?.usePeriod]
  ) {
    usePeriodCount = `${obj?.requiredInfoToConfirm?.usePeriodCount} ${
      periodEnum[obj?.requiredInfoToConfirm?.usePeriod]
    }`;
  }
  if (
    (obj?.requiredInfoToConfirm?.periodCount || obj?.requiredInfoToConfirm?.periodCount != 0) &&
    periodEnum[obj?.requiredInfoToConfirm?.periodCode]
  ) {
    periodCount = `${obj?.requiredInfoToConfirm?.periodCount} ${
      periodEnum[obj?.requiredInfoToConfirm?.periodCode]
    }`;
  }
  const data = generateDataDelegation(obj);
  let allFields = [
    ...shareFields(data),
    {
      titleEn: 'operationType',
      titleFa: 'نوع عملیات:',
      value: `${isGroup == true ? 'تفویض وجه گروهی' : 'تفویض وجه تکی'}`,
      isShow: true,
    },

    {
      titleEn: 'amount',
      titleFa: 'مبلغ:',
      value: (
        <>
          <PriceLabel amount={data?.amount} currency={currencyText}/>
        </>
      ),
      isShow: !!data?.amount,
    },

    {
      // فقط برای تفویض تکی نمایش داده میشود
      titleEn: 'name',
      titleFa: 'تخصیص به:',
      value: data?.name,
      isShow: !!data?.name,
    },
    {
      //  فقط برای تفویض تکی نمایش داده میشود
      titleEn: 'startDateEtebar',
      titleFa: 'تاریخ شروع اعتبار:',
      value: data?.startDate
        ? jMoment(
            jMoment(data?.startDate, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm:ss'),
          )?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.startDate,
    },
    {
      titleEn: 'expireDateEtebar',
      titleFa: 'تاریخ انقضا اعتبار:',
      value: data?.expireEndDate
        ? jMoment(
            jMoment(data?.expireEndDate, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm:ss'),
          )?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.expireEndDate,
    },

    {
      // فقط برای  تفویض تکی نمایش داده میشود
      titleEn: 'uniqueId',
      titleFa: 'شناسه یکتا:',
      value: data?.uniqueId,
      isShow: !!data?.uniqueId,
    },
    {
      titleEn: 'maxTryCount',
      titleFa: 'حداکثر دفعات مصرف:',
      value: data?.maxTryCount,

      isShow: !!data?.maxTryCount,
    },
    {
      titleEn: 'periodUsage',
      titleFa: 'بازه زمانی مصرف:',
      value: usePeriodCount,
      isShow: !!usePeriodCount,
    },
    {
      titleEn: 'periodAuto',
      titleFa: 'تمدید خودکار دوره ای:',
      value: periodCount,
      isShow: !!periodCount,
    },
    {
      titleEn: 'description',
      titleFa: 'شرح انتقال:',
      value: data?.description,
      isShow: !!data?.description,
    },
  ];
  return allFields;
};

/**
 * انتقال وجه
 */
export const transferCreditFields = (obj, isGroup = false, currencyText) => {
  const data = generateDataTransferCredit(obj);

  let allFields = [
    ...shareFields(data),
    {
      titleEn: 'destinationAccount',
      titleFa: 'نام حساب مقصد:',
      value: data?.destinationAccount,
      isShow: !!data?.destinationAccount,
    },

    {
      titleEn: 'operationType',
      titleFa: 'نوع عملیات:',
      value: `${isGroup == true ? 'انتقال وجه گروهی' : 'انتقال وجه تکی'} `,
      isShow: true,
    },
    {
      titleEn: 'amount',
      titleFa: 'مبلغ:',
      value: (
        <>
          <PriceLabel amount={data?.amount} currency={currencyText}/>
        </>
      ),
      isShow: !!data?.amount,
    },

    {
      titleEn: 'fullName',
      titleFa: 'اطلاعات مقصد:',
      value:
        data?.firstName || data?.lastName
          ? `${data?.firstName} ${data?.lastName}`
          : `${data?.username}`,
      isShow: !!(data?.firstName || data?.lastName) || !!data?.username,
    },

    {
      titleEn: 'description',
      titleFa: 'توضیحات:',
      value: data?.description,
      isShow: !!data?.description,
    },
  ];
  return allFields;
};

/**
 * بن شارژ
 */
export const creditVoutherFields = (obj, currencyText) => {
  const data = generateDataCreditVouther(obj);
  let allFields = [
    ...shareFields(data),
    {
      titleEn: 'operationType',
      titleFa: 'نوع عملیات:',
      value: 'بن شارژ',
      isShow: true,
    },

    {
      titleEn: 'startDate',
      titleFa: 'تاریخ شروع:',
      value: data?.startDate
        ? jMoment(
            jMoment(data?.startDate, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm:ss'),
          )?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.startDate,
    },
    {
      titleEn: 'expireEndDate',
      titleFa: 'تاریخ انقضا:',
      value: data?.expireEndDate
        ? jMoment(
            jMoment(data?.expireEndDate, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm:ss'),
          )?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.expireEndDate,
    },

    {
      titleEn: 'amount',
      titleFa: 'مبلغ:',
      value: (
        <>
          <PriceLabel amount={data?.amount} currency={currencyText}/>
        </>
      ),
      isShow: !!data?.amount,
    },
    {
      titleEn: 'count',
      titleFa: 'مقدار صادر شده (تعداد صادر شده):',
      value: data?.count,
      isShow: !!data?.count,
    },
    {
      titleEn: 'description',
      titleFa: 'توضیحات:',
      value: data?.description,
      isShow: !!data?.description,
    },
  ];
  return allFields;
};

/**
 * بن تخفیف
 */
export const discountVoutherFields = (obj, currencyText) => {
  const data = generateDataDiscountVouther(obj);
  let allFields = [
    ...shareFields(data),
    {
      titleEn: 'operationType',
      titleFa: 'نوع عملیات:',
      value: requestType[data?.typeCode],
      isShow: true,
    },
    {
      titleEn: 'startDate',
      titleFa: 'تاریخ شروع:',
      value: data?.startDate
        ? jMoment(
            jMoment(data?.startDate, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm:ss'),
          )?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.startDate,
    },
    {
      titleEn: 'expireEndDate',
      titleFa: 'تاریخ انقضا:',
      value: data?.expireEndDate
        ? jMoment(
            jMoment(data?.expireEndDate, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm:ss'),
          )?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.expireEndDate,
    },

    {
      titleEn: 'amount',
      titleFa: 'مبلغ صادر شده:',
      value: (
        <>
          <PriceLabel amount={data?.amount} currency={currencyText}/>
        </>
      ),
      isShow: !!(data?.amount && !data?.discountPercentage),
    },
    {
      titleEn: 'percentAmount',
      titleFa: 'درصد صادر شده:',
      value: `${data?.discountPercentage} درصد`,
      isShow: !!data?.discountPercentage,
    },
    {
      // اگر از نوع درصدی باشه ، سقف تخفیف وجود داره و فیلد amount است
      titleEn: 'ceilDiscount',
      titleFa: 'سقف تخفیف:',
      value: data?.amount,
      isShow: !!(data?.discountPercentage && data?.amount),
    },
    {
      titleEn: 'count',
      titleFa: 'تعداد صادر شده:',
      value: data?.count,
      isShow: !!data?.count,
    },
    {
      titleEn: 'description',
      titleFa: 'توضیحات:',
      value: data?.description,
      isShow: !!data?.description,
    },
  ];
  return allFields;
};

/**
 * فاکتور
 */
export const factorFields = (obj, currencyText) => {
  const data = generateDataFactor(obj);
  let allFields = [
    ...shareFields(data),
    {
      titleEn: 'operationType',
      titleFa: 'نوع عملیات:',
      value: 'فاکتور',
      isShow: true,
    },
    {
      titleEn: 'factorId',
      titleFa: 'شناسه فاکتور:',
      value: data?.factorId,
      isShow: !!data?.factorId,
    },
    {
      titleEn: 'date',
      titleFa: 'تاریخ  صدور:',
      value: data?.date
        ? jMoment(new Date(parseInt(data?.date)))?.format('dddd, jD jMMMM jYYYY') ?? '-'
        : '-',
      isShow: !!data?.date,
    },
    {
      titleEn: 'allPrice',
      titleFa: 'مبلغ کل:',
      value: (
        <>
          <PriceLabel amount={data?.allPrice} currency={currencyText}/>
        </>
      ),
      isShow: !!data?.allPrice,
    },
    {
      titleEn: 'sellerName',
      titleFa: 'نام فروشنده:',
      value: data?.sellerName,
      isShow: !!data?.sellerName,
    },
    {
      // اگر از نوع درصدی باشه ، سقف تخفیف وجود داره و فیلد amount است
      titleEn: 'buyName',
      titleFa: 'نام خریدار:',
      value: data?.buyName,
      isShow: !!data?.buyName,
    },
  ];
  return allFields;
};
